// docs/71 INV9: one line of flavour per catalogue piece, shown under its name in the details
// card. Words only: nothing here changes what a piece does (that is the catalogue's numbers).
import { garbPiece } from '../../game/starterGarb';

const LORE: Record<number, string> = {
  100: 'Steel with a good balance: the first blade most heroes learn to trust.',
  101: 'Heavy enough to argue with doors, and with whatever stands behind them.',
  102: 'A flanged head that finds the gap in a guard where an edge would skate.',
  103: 'Quick, quiet, and just as useful in the off hand as the main one.',
  104: 'Keeps the trouble one long step away.',
  105: 'Yew and gut and patience. Twice as far as anyone expects.',
  106: 'Slow to wind, sure to land.',
  107: 'Walking stick, lightning rod and argument-ender all in one.',
  108: 'A finger of carved bone that points where the spell should go.',
  110: 'A fist-sized boss of iron for turning a blow aside.',
  111: 'Painted once, scarred since. It still holds.',
  112: 'Tall enough to hide behind and stubborn enough to stand.',
  113: 'A wall you carry. Your legs will notice.',
  114: 'A crystal that hums when held near a spell half-formed.',
  120: 'Wool and linen, patched at the elbows.',
  121: 'Boiled hide, oiled and buckled: armour that does not slow you down.',
  122: 'Ten thousand rings, each one a promise.',
  123: 'Iron shaped to a body. You do not walk so much as advance.',
  130: 'A padded cap: better than a bare head, and warmer.',
  131: 'A broad brim of iron that sheds arrows like rain.',
  132: 'You will hear less and see less. You will also live longer.',
  140: 'Waxed against the weather; the road never slows its wearer.',
  141: 'Deep enough to see out of while the fog sees nothing.',
  142: 'Stitched with sigils somebody swore were protective.',
  143: 'Heavy as a blanket, and as hard to push over.',
  150: 'Plain iron, worn smooth by a long line of wearers.',
  151: 'A whetstone on a thong. A habit as much as a charm.',
  152: 'Burns steady in wind and rain, and lights the way through the dark.',
  153: "A runner's knot: slip it and you slip away, and arrive swinging.",
  154: 'Chewed leaves for the small cuts between the big ones.',
  160: 'Smells of comfrey and honey. Rub it in and grit your teeth.',
  161: 'Bitter, fizzing, and gone too quickly.',
  162: 'Crack it and be elsewhere, as far as anyone can tell.',
  163: 'Read it aloud once and the field gives up its secrets.',
  170: 'Supple calfskin; fingers stay quick and dry.',
  171: 'Iron knuckles over leather. A fist becomes an argument.',
  172: 'Ribbons of silk stitched with patterns that move when you are not looking.',
  180: 'Soft soles for quiet floors.',
  181: 'Hobnailed and heavy: they do not slip, and neither do you.',
  182: 'They seem to know where you mean to go a step before you do.',
  190: 'A red stone on a chain, warm as a heartbeat.',
  191: 'A blue drop of glass that turns a blade aside, sometimes.',
  192: 'A twisted ring of copper that never quite stops being cold.',
};

/** A hand-authored piece's line, or a starter garb piece's flavour (docs/144). */
export const loreOf = (def: number): string | undefined => LORE[def] ?? garbPiece(def)?.flavour;
